<template>
    <v-container fluid class="pa-8">
    <v-text-field
      v-model="search"
      label="Buscar gênero..."
      prepend-inner-icon="mdi-magnify"
      outlined
      dark
      class="search-bar mb-6 custom-input"
      @input="list()"
      clearable
    ></v-text-field>
    <v-btn class="my-5 zinnes-primary-btn" dark @click="novo()">Novo Gênero</v-btn>
    <v-simple-table class="custom-table">
      <thead>
        <tr>
          <th class="text-left">Id</th>
          <th class="text-left">Nome</th>
          <th class="text-left">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="gender in genres"
          :key="gender.id"
          style="height: 70px; font-size: 16px;"
        >
          
          <td>{{ gender.id }}</td>
          <td>{{ gender.name }}</td>
          <td>
            <v-btn icon @click="select(gender)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <div class="text-center">
          <v-pagination color="var(--zinnes-primary)" 
            v-model="paginate.current_page" 
            :length="paginate.last_page"
            total-visible="5"
            @input="list"
            ></v-pagination>
    </div>
    <ModalGender ref="modal" :list="list"></ModalGender>
  </v-container>
</template>
<script>
import UtilMixins from '@/mixins/UtilMixins';
import GenderService from '@/server/GenderService';
import ModalGender from './ModalGender.vue';


export default {
    mixins:[UtilMixins],
    components:{ModalGender},
    data:() => ({
        service: new GenderService(),
        search:'',
    }),
    computed:{
        genres:{
            get(){return this.$store.getters['getGenders']},
            set(dado){this.$store.dispatch('setGenders', dado)}
        }
    },
    mounted(){
        this.list()
    },
    methods:{
        list(page=1){
            let params = {
                page,
                name:this.search,
            }
            console.log(params);

            this.service.list(params)
            .then(res => {                              
                this.genres = res.data;
                this.paginate = res;
            })
        },
        novo(){
            this.$refs.modal.abrirModal();
        },
        select(data){
            console.log(data);
            this.$store.dispatch('setGender', data)
            this.$refs.modal.abrirModal();
        }
    }
}
</script>